import React from "react";
import SharedEditPhone from "@/features/phone-verification/EditPhone.jsx";
export default function EditPhone() { return <SharedEditPhone role="patient" />; }
